import VueNotify from '../components/app/Notify.vue'

export default {
  install (Vue, options = {}) {
    // Create component instance
    let Constr = Vue.extend(VueNotify);
    let Notify = new Constr();

    // Apply configuration
    Notify.options = Object.assign(Notify.options, options);

    // Mount it
    let vm = Notify.$mount();

    // Add it to the Vue application
    document.querySelector('body').appendChild(vm.$el);

    // Create generic method
    Vue.$notify = Vue.prototype.$notify = (msg, type = 'info', options = {}, staticIndex = null) => {
      return Notify.addItem(type, msg, options, staticIndex);
    };
    Vue.$notify.info = Vue.prototype.$notify.info = (msg, options = {}, staticIndex = null) => {
      return Notify.addItem('info', msg, options, staticIndex);
    };
    Vue.$notify.success = Vue.prototype.$notify.success = (msg, options = {}, staticIndex = null) => {
      return Notify.addItem('success', msg, options, staticIndex);
    };
    Vue.$notify.error =
      Vue.prototype.$notify.error =
        Vue.$notify.danger =
          Vue.prototype.$notify.danger = (msg, options = {}, staticIndex = null) => {
            return Notify.addItem('error', msg, options, staticIndex);
          };
    Vue.$notify.warning = Vue.prototype.$notify.warning = (msg, options = {}, staticIndex = null) => {
      return Notify.addItem('warning', msg, options, staticIndex);
    };
    // Create setTypes method
    Vue.$notify.setTypes = Vue.prototype.$notify.setTypes = (types) => {
      Notify.setTypes(types);
    };
    Vue.$notify.removeAll = Vue.prototype.$notify.removeAll = () => {
      Notify.removeAll();
    };
    Vue.$notify.remove = (index) => {
      Notify.removeItem(index);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/notify.js